/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {forwardRef, useEffect, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useMutation, useQuery} from "@apollo/react-hooks";
import {CREATE_ACCOUNT, GET_ACCOUNT, GET_ACCOUNTS_BY_NAME} from "../../database/queries/accountQueries";
import CircularProgress from "@material-ui/core/CircularProgress";
import {notify} from "../../utils/notify";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& p': {
            color: 'red',
        }
    },
    formControl: {
        'input': {
            '&::placeholder': {
                color: 'blue'
            }
        },
        '& .MuiFormLabel-root': {
            color: '#a0aec0'
        },
    },
    formControlError: {
        'input': {
            '&::placeholder': {
                color: 'red'
            }
        },
        '& .MuiFormLabel-root': {
            color: 'red'
        },
        '& .MuiInput-underline:before': {
            borderColor: 'red'
        },
    },
}));


const ChooseOrAddAccount = forwardRef((props, ref) => {
    const classes = useStyles();
    const [target, setTarget] = useState({id: props.accountId, name: props.accountName});
    const [dialogOpen, setDialogOpen] = useState(false);
    const [autocompleteFilter, setAutocompleteFilter] = useState('');
    const [autocompleteOptions, setAutocompleteOptions] = useState([]);
    const [autocompleteOpen, setAutocompleteOpen] = React.useState(false);
    const [errors, setErrors] = useState({});
    const [dialogValue, setDialogValue] = useState({
        accountName: props.accountName,
    });

    const {data: getAccountData} = useQuery(GET_ACCOUNT, {
        skip: !props.accountId,
        variables: {accountId: props.accountId},
    });

    const {loading: getAccountsByNameLoading, error: getAccountsByNameError, refetch: getAccountsByNameRefetch} = useQuery(GET_ACCOUNTS_BY_NAME, {
        skip: autocompleteFilter.length === 0,
        variables: {
            searchStr: autocompleteFilter,
            limit: 5,
            orderList: ['accountName ASC']
        },
    });

    const [createAccount] = useMutation(CREATE_ACCOUNT);

    const tellParent = (target) => {
        props.onChange(target);
    };

    useEffect(() => {
        if (getAccountData && getAccountData.account) {
            const newTarget = {id: getAccountData.account.accountId, name: getAccountData.account.accountName};
            tellParent(newTarget);
            setTarget(newTarget);
        }
    }, [getAccountData]);

    useEffect(() => {
        if (getAccountsByNameError) notify('getAccountsByNameError', 'error', getAccountsByNameError.message);
    }, [getAccountsByNameError]);

    useEffect(() => {
        if (autocompleteFilter && autocompleteFilter.length > 0) {
            getAccountsByNameRefetch()
                .then((result) => {
                    let myAccounts = [];
                    if (result.data && result.data.accountsByName) {
                        result.data.accountsByName.map(account => myAccounts.push({
                                id: account.accountId,
                                name: account.accountName
                            })
                        );
                    }
                    setAutocompleteOptions(myAccounts);
                })
                .catch(e => {
                    console.trace(e);
                });
        }
    }, [autocompleteFilter, getAccountsByNameRefetch]);

    useEffect(() => {
        if (!autocompleteOpen) {
            setAutocompleteOptions([]);
        }
    }, [autocompleteOpen]);

    useEffect(() => {
        if (props.accountName) {
            setAutocompleteFilter(props.accountName);
            setAutocompleteOpen(true);
        }
    }, [props.accountName]);

    const handleDialogClose = () => {
        setDialogValue({
            accountName: '',
        });
        setDialogOpen(false);
    };

    const validateDialog = () => {
        setErrors({});
        let newError = {};

        if (!dialogValue.accountName || dialogValue.accountName.length < 3) newError.accountName = 'Account name must be at least 3 characters long';
        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    }

    const handleDialogSave = (event) => {
            if (validateDialog()) {
                createAccount({
                    variables: {
                        newAccount: {
                            accountName: dialogValue.accountName
                        }
                    }
                }).then((createResult) => {
                    const newTarget = {
                        id: createResult.data.createAccount.id,
                        name: createResult.data.createAccount.name
                    };
                    setTarget(newTarget)
                    tellParent(newTarget)
                    handleDialogClose();
                }).catch(e => {
                    setErrors({other: 'Some problem creating account'})
                })
            }
        }
    ;

    return (
        <>
            <Autocomplete
                id="choose-account-autocomplete"
                ref={ref}
                name="choose-account-autocomplete"
                value={target}
                open={autocompleteOpen}
                onOpen={() => {
                    setAutocompleteOpen(true);
                }}
                onClose={() => {
                    setAutocompleteOpen(false);
                }}
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        // timeout to avoid instant validation of the dialog's form.
                        setTimeout(() => {
                            setDialogOpen(true);
                            setDialogValue({
                                accountName: newValue
                            });
                        });
                    } else if (newValue && newValue.inputValue) {
                        setDialogOpen(true);
                        setDialogValue({
                            accountName: newValue.inputValue,
                        });
                    } else {
                        setTarget(newValue);
                        tellParent(newValue);
                    }
                }}
                onInputChange={(event, value, reason) => {
                    setAutocompleteFilter(value);
                }}
                onBlur={e => {
                    if (!target.id || target.id === '') {
                        setDialogOpen(true);
                        setDialogValue({
                            accountName: e.target.value,
                        });
                    }
                }}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                        return option;
                    }
                    if (option.name) {
                        return option.name;
                    }
                    return option.name;
                }}
                options={autocompleteOptions}
                loading={getAccountsByNameLoading}
                selectOnFocus
                renderOption={(option) => option.name}
                style={{width: '100%'}}
                freeSolo
                renderInput={params => {
                    return (
                        <TextField
                            {...params}
                            label="Find Account"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {getAccountsByNameLoading ?
                                            <CircularProgress color="inherit"
                                                              size={20}/> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )
                }}
            />
            <Dialog open={dialogOpen} onClose={handleDialogClose} aria-labelledby="form-dialog-account-name">
                <DialogTitle id="form-dialog-account-name">Add new account</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Do you want to add this account?
                    </DialogContentText>
                    <FormControl
                        className={errors.accountName ? classes.formControlError : classes.formControl}
                        margin="dense"
                        size="small"
                        fullWidth
                    >
                        <TextField
                            // autoFocus
                            // onFocus={e => e.currentTarget.select()}
                            fullWidth
                            margin="dense"
                            id="accountName"
                            value={dialogValue.accountName}
                            onChange={(event) => setDialogValue({
                                ...dialogValue,
                                accountName: event.target.accountName
                            })}
                            label="account name"
                            type="text"
                        />
                        <FormHelperText>
                            {errors.accountName}
                        </FormHelperText>
                    </FormControl>
                    {errors.other}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDialogSave} color="primary">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
});

export default ChooseOrAddAccount
